import { processHistorical } from "@/_core/data/api_calls/relatives_values/historical/processHistorical";

/**
 * Retrieves historical data for commodity relative values.
 * @param {object} ctx - Context variables containing asset data.
 * @param {object} assetExtraParams - Extra parameters needed for the query (e.g., commodity number and contract).
 * @returns {Promise} - A promise that resolves to the historical data for commodities.
 */
export function getHistCommodities(ctx, assetExtraParams) {
  // Define the parameters for the GET request
  let params = {
    method: "GET", // HTTP method for the request
    endpoint: "relatives_values_historical_commodities", // API endpoint to fetch historical commodity relative values
    content_type: "application/json", // Content type for the request
    query_params: {
      format: "json", // Ensure the response is in JSON format
      commodity: assetExtraParams.commodityNumber, // Commodity number from the extra parameters
      contract: assetExtraParams.contract, // Contract information from the extra parameters
      correlations: false // Exclude correlation data
    }
  };

  // Process and return the historical commodity data by calling the processHistorical function
  return processHistorical(ctx, params);
}
